<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.students', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="bg-white">
            <div class="max-w-7xl mx-auto py-12 px-4 text-center sm:px-6 lg:px-8 lg:py-24">
                <div class="space-y-12">
                    <div class="space-y-5 sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl">
                        <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">
                            {{ $t('messages.choose_student') }}
                        </h2>
                        <p class="text-xl text-gray-500"></p>
                    </div>
                    <ul
                        class="mx-auto space-y-16 sm:grid sm:grid-cols-2 sm:gap-16 sm:space-y-0 lg:grid-cols-3 lg:max-w-5xl"
                    >
                        <li v-for="student in students" :key="student.id">
                            <div class="space-y-6">
                                <a :href="student.url">
                                    <img
                                        class="mx-auto h-40 w-40 rounded-full"
                                        :src="student.avatar_or_default"
                                        alt="avatar"
                                    />
                                </a>
                                <div class="space-y-2">
                                    <div class="text-lg leading-6 font-medium space-y-1">
                                        <h3>
                                            <a :href="student.url">
                                                {{ student.full_name }}
                                            </a>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'students'],
};
</script>
